/* eslint-disable react/display-name */
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import TopBarNav from '../TopBarNav'
import CommonStyles from '../CommonStyles'
import BreadcrumbsHistory from '../BreadcrumbsHistory'
import { Backdrop, CircularProgress, Container, Grid, withStyles } from '@material-ui/core'
import { connect } from 'react-redux'
import * as navigationActions from '../../../actions/common/NavigationActions'
import * as UserProfileActions from '../../../actions/common/UserProfileActions'
import { bindActionCreators } from 'redux'
import { TreeView } from '@material-ui/lab'
import StyledTreeItem from '../StyledTreeItem'
import Label from '@material-ui/icons/Label';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import { MinusSquare, PlusSquare } from '../TreeViewUtils'
import { useTranslation } from 'react-i18next'
import { Footer } from '../Footer'
import Modal from 'antd/es/modal';
import { Link as RouterLink } from 'react-router-dom';
import Link from '@material-ui/core/Link'


const Home = ({ classes, ...props }) => {
  const history = useHistory()
  const [open, setOpen] = useState(false);
  const { t } = useTranslation()

  useEffect(() => {
    handleOpen()
    props.navigationActions.clean_routes()
    props.userProfileActions.fetch_User_Profile(props.userLanguage, props.userToken, onError, onSuccess)
    return () => {
      props.cleanUserProfile()
    }
  }, [])// eslint-disable-line react-hooks/exhaustive-deps

  const handleClose = () => {
    setOpen(false);
  }
  const handleOpen = () => {
    setOpen(true);
  }
  const onSuccess = () => {
    handleClose()
  }

  const onError = (err) => {
    if (err.response && err.response.status) {
      switch (err.response.status) {
        case 401:
          props.tokenExpired()
          history.push('/login')
          break
        case 403:
          Modal.error({
            title: 'Error',
            content: t('commonMessages.alert403')
          })
          props.tokenExpired()
          history.push('/login')
          break
        case 500:
          Modal.error({
            title: 'Error',
            content: t('commonMessages.alert500')
          })
          break
        default:
          break
      }
    }
  }

  const handleClick = (serviceName, branchOfficeId) => {
    switch (serviceName) {
      case 'Fuel':
        history.push(`/fuel/${branchOfficeId}`)
        break
      case 'Trucks':
        history.push(`/trucks/${branchOfficeId}`)
        break
      case 'Gestoria':
        history.push(`/collateral/${branchOfficeId}`)
        break
      case 'Seguros':
        history.push(`/insurance/${branchOfficeId}`)
        break
      case 'Telemáticos':
        history.push(`/telematics/${branchOfficeId}`)
        break
      case 'Indirectos':
        history.push(`/indirect/${branchOfficeId}`)
        break
      case 'SL&B':
        history.push(`/slb/${branchOfficeId}`)
        break
      case 'Adquisición Vehiculos':
        history.push(`/purchase/${branchOfficeId}`)//branchOfficeId = SupplierId
        break
      case 'Mantenimiento':
        history.push(`/maintenance/${branchOfficeId}`)
        break
      default:
        break
    }
  }
  return (
    <div>
      <TopBarNav />
      <br />
      <BreadcrumbsHistory />
      <br />
      <Container fixed className={classes.root} style={{ height: '70vh', overflow: 'auto' }}>
        <Backdrop className={classes.backdrop} open={open}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <Grid container item xs={12} spacing={3} >
          <Grid item xs={12} className={classes.dashboardAlign}>
            <br />
            <h3>{t('home')}</h3>
          </Grid>
        </Grid>
        <Grid container item xs={12} spacing={3}>
          <TreeView
            className={classes.rootTreeView}
            defaultExpanded={['']}
            defaultCollapseIcon={<MinusSquare />}
            defaultExpandIcon={<PlusSquare />}
            defaultEndIcon={<div style={{ width: 24 }} />}
          >
            {
              props.groups && props.groups.length > 0 &&
              <StyledTreeItem nodeId="1" labelText={t('common.groups')} labelIcon={Label} labelInfo={props.groups && props.groups.length > 0 ? props.groups.length.toString() : '0'}>
                {
                  props.groups.map((item, index) => (
                    <StyledTreeItem key={item.groupName} nodeId={`group-${index}`} labelText={item.groupName} labelIcon={SupervisorAccountIcon} >
                      {
                        item.suppliers && item.suppliers.map((supplier, indexSup) => (
                          <StyledTreeItem key={indexSup} nodeId={`group-supplier-${indexSup}`} labelText={supplier.supplierName} labelIcon={SupervisorAccountIcon}>
                            {                              
                              supplier.branchOffices && supplier.branchOffices.map((branchOffice, indexBranch) => (
                                <StyledTreeItem key={indexBranch} nodeId={`group-supplier-branchOffice-${indexBranch}`} labelText={branchOffice.branchOfficeName} labelIcon={SupervisorAccountIcon} color="#1a73e8" bgColor="#e8f0fe">
                                  {
                                    branchOffice.branchOfficeServices && branchOffice.branchOfficeServices.map((service, indexService) => (
                                      // service.serviceName && <StyledTreeItem onClickFunction={() => handleClick(service.serviceName, branchOffice.id)} key={indexService} nodeId={service.serviceName} labelText={service.serviceName} labelIcon={SupervisorAccountIcon} color="#1a73e8" bgColor="#e8f0fe">
                                      service.serviceName && <StyledTreeItem onClickFunction={() => 
                                      handleClick(service.serviceName, (service.serviceName === 'Adquisición Vehiculos' ? supplier.id : branchOffice.id))} 
                                      key={indexService} nodeId={`group-supplier-branchOffice-service-${indexService}`} 
                                      labelText={t(`homeDefinitions.${service.serviceName}`)} 
                                      labelIcon={SupervisorAccountIcon} color="#1a73e8" bgColor="#e8f0fe">

                                      </StyledTreeItem>
                                    ))
                                  }
                                </StyledTreeItem>
                              ))
                            }
                          </StyledTreeItem>
                        ))
                      }
                    </StyledTreeItem>
                  ))
                }
              </StyledTreeItem>
            }
            {
              props.suppliers && props.suppliers.length > 0 &&
              <StyledTreeItem nodeId="2" labelText={t('common.providers')} labelIcon={Label} labelInfo={props.suppliers && props.suppliers.length > 0 ? props.suppliers.length.toString() : '0'}>
                {
                  props.suppliers.map((supplier, indexSup) => (
                    <StyledTreeItem key={indexSup} nodeId={`supplier-${indexSup}`} labelText={supplier.supplierName} labelIcon={SupervisorAccountIcon}>
                      {                        
                          supplier.branchOffices && supplier.branchOffices.map((branchOffice, indexBranch) => (
                            <StyledTreeItem key={indexBranch} nodeId={`group-supplier-branchOffice-${indexBranch}`} labelText={branchOffice.branchOfficeName} labelIcon={SupervisorAccountIcon} color="#1a73e8" bgColor="#e8f0fe">
                              {
                                branchOffice.branchOfficeServices && branchOffice.branchOfficeServices.map((service, indexService) => (
                                  // service.serviceName && <StyledTreeItem onClickFunction={() => handleClick(service.serviceName, branchOffice.id)} key={indexService} nodeId={service.serviceName} labelText={service.serviceName} labelIcon={SupervisorAccountIcon} color="#1a73e8" bgColor="#e8f0fe">
                                  service.serviceName && <StyledTreeItem onClickFunction={() => 
                                  handleClick(service.serviceName, (service.serviceName === 'Adquisición Vehiculos' ? supplier.id : branchOffice.id))} 
                                  key={indexService} nodeId={`group-supplier-branchOffice-service-${indexService}`} 
                                  labelText={t(`homeDefinitions.${service.serviceName}`)} 
                                  labelIcon={SupervisorAccountIcon} color="#1a73e8" bgColor="#e8f0fe">

                                  </StyledTreeItem>
                                ))
                              }
                            </StyledTreeItem>
                          ))
                      }
                    </StyledTreeItem>
                  ))
                }
              </StyledTreeItem>
            }
            {
              props.branchOffices && props.branchOffices.length > 0 &&
              <StyledTreeItem nodeId="3" labelText={t('common.branchOffices')} labelIcon={Label} labelInfo={props.branchOffices && props.branchOffices.length > 0 ? props.branchOffices.length.toString() : '0'}>
                {
                  props.branchOffices.map((branchOffice, indexBranch) => (
                    <StyledTreeItem key={indexBranch} nodeId={`branchOffice-${indexBranch}`} labelText={branchOffice.branchOfficeName} labelIcon={SupervisorAccountIcon} color="#1a73e8" bgColor="#e8f0fe">
                      {
                        branchOffice.branchOfficeServices && branchOffice.branchOfficeServices.map((service, indexService) => (
                          // service.serviceName && <StyledTreeItem onClickFunction={() => handleClick(service.serviceName, branchOffice.id)} key={indexService} nodeId={service.serviceName} labelText={service.serviceName} labelIcon={SupervisorAccountIcon} color="#1a73e8" bgColor="#e8f0fe">
                          service.serviceName && <StyledTreeItem onClickFunction={() => handleClick(service.serviceName, branchOffice.id)} key={indexService} nodeId={`branchOffice-service-${indexService}`} labelText={t(`homeDefinitions.${service.serviceName}`)} labelIcon={SupervisorAccountIcon} color="#1a73e8" bgColor="#e8f0fe">

                          </StyledTreeItem>
                        ))
                      }
                    </StyledTreeItem>
                  ))
                }
              </StyledTreeItem>
            }
            {
              props.branchOfficeServices && props.branchOfficeServices.length > 0 &&
              <StyledTreeItem nodeId="4" labelText={t('common.services')} labelIcon={Label} labelInfo={props.branchOfficeServices && props.branchOfficeServices.length > 0 ? props.branchOfficeServices.length.toString() : '0'}>
                {props.branchOfficeServices.map((service, indexService) => (
                  // service.serviceName && <StyledTreeItem onClickFunction={() => handleClick(service.serviceName, service.branchOfficeId)} key={indexService} nodeId={service.branchOfficeName + '' + service.serviceName} labelText={service.branchOfficeName + ': ' + service.serviceName} labelIcon={SupervisorAccountIcon} color="#1a73e8" bgColor="#e8f0fe">
                  service.serviceName && <StyledTreeItem onClickFunction={() => handleClick(service.serviceName, service.branchOfficeId)} key={indexService} nodeId={`service-${indexService}`} labelText={service.branchOfficeName + ': ' + t(`homeDefinitions.${service.serviceName}`)} labelIcon={SupervisorAccountIcon} color="#1a73e8" bgColor="#e8f0fe">

                  </StyledTreeItem>
                ))
                }
              </StyledTreeItem>
            }
            {
              (props.role.includes("Installer") === true) &&
              <div>
                <br />
                <Link component={RouterLink} to={`/telematics/InstallationOrders/My`}>{t('telematicsInstallers.myInstallationOrders')}</Link>
              </div>
            }
          </TreeView>

        </Grid>
      </Container>
      <Footer />
    </div >
  )
}

const mapStateToProps = state => ({
  isUserAuthenticated: state.LoginReducer.isAuthenticated,
  userToken: state.LoginReducer.token,
  userLanguage: state.LoginReducer.language,
  navList: state.NavigationReducer.routeList,
  groups: state.UserProfileReducer.groups,
  suppliers: state.UserProfileReducer.suppliers,
  branchOffices: state.UserProfileReducer.branchOffices,
  branchOfficeServices: state.UserProfileReducer.branchOfficeServices,
  role: state.LoginReducer.role
})

const mapDispatchToProps = dispatch => {
  return {
    tokenExpired: () => dispatch({ type: 'TOKEN_EXPIRED' }),
    cleanUserProfile: () => dispatch({ type: 'CLEAN_USER_PROFILE' }),
    navigationActions: bindActionCreators(navigationActions, dispatch),
    userProfileActions: bindActionCreators(UserProfileActions, dispatch)
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(CommonStyles)(Home))
